import React, { useState ,useEffect}  from "react";
import "./Logger.scss";
import TablePlot from "../../../components/Admin/Graphs/Table";
import { ip } from "../../../api/config";
import { getUserRol} from "../../../api/user";
import {
  getRefreshTokenApi,
  getAccessTokenApi,
  getPublicIP
} from "../../../api/auth";
import {notification} from "antd";
import {
  Button
} from "antd";



const columns = [
  {
    title: "Iteration",
    key: "Iteration",
    dataIndex: "Iteration",
    /* render: (_, { tags }) => (
      <>
        {tags.map((tag) => {
          // let color = tag.length > 5 ? "geekblue" : "green";
          var color;
          if (tag === "Expired") {
            color = "volcano";
          } else if (tag === "Deny") {
            color = "orange";
          } else if (tag === "Soon") {
            color = "yellow";
          } else {
            color = "green";
          }
          return (
            <Tag color={color} key={tag}>
              {tag.toUpperCase()}
            </Tag>
          );
        })}
      </>
    ), */
  },
  {
    title: "IP",
    dataIndex: "IP",
    key: "IP",
    /* render: (_, { tags }) => (
      <>
        {tags.map((tag) => {
          var teg = tag.replace('::ffff:','')
          return (
            <Tag  key={tag}>
              {teg.toUpperCase()}
            </Tag>
          );
        })}
      </>
    ), */
    /* render: (_, { Licenses }) => (
      <>
        <a
          href="https://ishareworks.atlassian.net/wiki/spaces/IS/pages/70221903/Licenses"
          target="_blank"
          rel="noreferrer"
        >
          {Licenses}
        </a>
      </>
    ), */
  },
  {
    title: "Date",
    dataIndex: "Date",
    key: "Date",
  },
  {
    title: "Function",
    dataIndex: "Function",
    key: "Function",
  },
];

const columnsError = [
  {
    title: "Iteration",
    key: "Iteration",
    dataIndex: "Iteration",
  },
  {
    title: "IP",
    dataIndex: "IP",
    key: "IP",
  },
  {
    title: "Date",
    dataIndex: "Date",
    key: "Date",
  },
  {
    title: "Error",
    dataIndex: "Function",
    key: "Function",
  },
  {
    title: "Message",
    dataIndex: "Message",
    key: "Message",
  },
];

function getHistory() {
  var status;
  var urlFetch='';
  var messag='';
    //console.log('entro')  
    const refreshToken = getRefreshTokenApi();
    const accessToken = getAccessTokenApi();

    var url
    if (process.env.REACT_APP_API_URL === 'localhost') {
      url = `http://${ip}:3004/history`;
    }else{
      url = `https://${ip}:3004/history`;
    }

    const params = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        // Authorization: "Bearer " + accessToken,
        // refreshToken: "Bearer " + refreshToken,
        // functionname:'getUsersApi'
      },
    };
    
      return fetch(url, params)
    .then((response) => {
      status=response.status;
      urlFetch=response.url;
      urlFetch=urlFetch.replace(`https://${ip}:3004/`,'')
      
      return response.json();
    })
    .then((result) => {
      
      if(status!==200){
        messag=result.message
        notification["error"]({
        message: `Error ${status} in function: ${urlFetch}`,
        description:messag
      });
      }
      //console.log(result.Historia)
      return result;
    })
    .catch((err) => {
      return err.message;
    });
}

function getHistoryError() {
  var status;
  var urlFetch='';
  var messag='';
    //console.log('entro')  
    const refreshToken = getRefreshTokenApi();
    const accessToken = getAccessTokenApi();
    var url
    if (process.env.REACT_APP_API_URL === 'localhost') {
      url = `http://${ip}:3004/historyError`;
    }else{
      url = `https://${ip}:3004/historyError`;
    }

    const params = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        // Authorization: "Bearer " + accessToken,
        // refreshToken: "Bearer " + refreshToken,
        // functionname:'example'
      },
    };
    
      return fetch(url, params)
    .then((response) => {
      status=response.status;
      urlFetch=response.url;
      urlFetch=urlFetch.replace(`https://${ip}:3004/`,'')
      
      return response.json();
    })
    .then((result) => {
      
      if(status!==200){
        messag=result.message
        notification["error"]({
        message: `Error ${status} in function: ${urlFetch}`,
        description:messag
      });
      }
      //console.log(result.Historia)
      return result;
    })
    .catch((err) => {
      return err.message;
    });
}

function getContar() {
  var status;
  var urlFetch='';
  var messag='';
    //console.log('entro')  
    const refreshToken = getRefreshTokenApi();
    const accessToken = getAccessTokenApi();
    const ippublica = getPublicIP();
    // console.log('ippp: ',ippublica)
    var url
    if (process.env.REACT_APP_API_URL === 'localhost') {
      url = `http://${ip}:3004/function`;
    }else{
      url = `https://${ip}:3004/function`;
    }

    const params = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        // Authorization: "Bearer " + accessToken,
        // refreshToken: "Bearer " + refreshToken,
         functionname:'example',
         ippublica:ippublica
      },
    };
    
      return fetch(url, params)
    .then((response) => {
      status=response.status;
      urlFetch=response.url;
      urlFetch=urlFetch.replace(`https://${ip}:3004/`,'')
      return response.json();
    })
    .then((result) => {
      
      if(status!==200){
        messag=result.message
        notification["error"]({
        message: `Error ${status} in function: ${urlFetch}`,
        description:messag
      });
      }else{
        messag=result.message
        notification["success"]({
          message: `Iteration added correctly`,
          description:messag
        });
      }
      return result;
    })
    .catch((err) => {
      return err.message;
    });
}

function getContarError() {
  var status;
  var urlFetch='';
  var messag='';
    //console.log('entro')  
    const refreshToken = getRefreshTokenApi();
    const accessToken = getAccessTokenApi();
    var url
    if (process.env.REACT_APP_API_URL === 'localhost') {
      url = `http://${ip}:3004/contarError`;
    }else{
      url = `https://${ip}:3004/contarError`;
    }

    const params = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        // Authorization: "Bearer " + accessToken,
        // refreshToken: "Bearer " + refreshToken,
         functionname:'example',
         message:'message example',
         ippublica:getPublicIP()
      },
    };
    
      return fetch(url, params)
    .then((response) => {
      status=response.status;
      urlFetch=response.url;
      urlFetch=urlFetch.replace(`https://${ip}:3004/`,'')
      return response.json();
    })
    .then((result) => {
      
      if(status!==200){
        messag=result.message
        notification["error"]({
        message: `Error ${status} in function: ${urlFetch}`,
        description:messag
      });
      }else{
        messag=result.message
        notification["success"]({
          message: `Iteration added correctly`,
          description:messag
        });
      }
      return result;
    })
    .catch((err) => {
      return err.message;
    });
}

export default  function Logger() {
  const[json,setJson]=useState()
  const[dataSource,setdataSource]=useState([])
  const[jsonError,setJsonError]=useState()
  const[dataSourceError,setdataSourceError]=useState([])
  
  try {
    var dataSources = [];
    var dataSourcesError = [];
    useEffect(() => {
      getUserRol(getAccessTokenApi()).then((response)=>{
        // console.log(response==='admin')
        if(response!=='admin'){
          window.location.href = "/admin/instructions";
        }
  
        return;
      })
      getHistory().then((response) => {
        setJson(JSON.stringify(response, null, 2))
        for(var i=0;i<response.Historia.length;i++){
          var aux=response.Historia[i].Hora.replace('T','  ');
          dataSources.push({
            Iteration:response.Historia[i].iteracion,
            IP:response.Historia[i].IP??'',
            Date: aux.substr(0, aux.length - 2),
            Function: response.Historia[i].function??''
          });
        }
        
        dataSources.sort(function (a, b) {
            if (a.Iteration < b.Iteration) {
              return 1;
            } else if (a.Iteration > b.Iteration) {
              return -1;
            } else {
              return 0;
            }
          
        });
        
        setdataSource(dataSources)
      })

      getHistoryError().then((response) => {
        setJsonError(JSON.stringify(response, null, 2))
        for(var i=0;i<response.Historia.length;i++){
          var aux=response.Historia[i].Hora.replace('T','  ');
          dataSourcesError.push({
            Iteration:response.Historia[i].iteracion,
            IP:response.Historia[i].IP??'',
            Date: aux.substr(0, aux.length - 2),
            Function: response.Historia[i].function??'',
            Message:response.Historia[i].message??''
          });
        }
        
        dataSourcesError.sort(function (a, b) {
            if (a.Iteration < b.Iteration) {
              return 1;
            } else if (a.Iteration > b.Iteration) {
              return -1;
            } else {
              return 0;
            }
          
        });
        
        setdataSourceError(dataSourcesError)
      })
    }, []);
     
    
  } catch (err) {
  //  console.log(err);
  }

  return (
    <>
      <h2 style={{fontFamily: 'report-bold'}}>Logger history: </h2>
      <div style={{border: '5px solid rgb(203,234,247)',marginBottom:'10px'}}>
        <TablePlot data={dataSource} columns={columns} />
      </div>
      <div className="quieroRow">
        <h3 style={{fontFamily: 'report',marginTop:'5px'}}>
          Add iteration:
        </h3>
        <p> &nbsp;&nbsp;&nbsp; </p>
        <Button className="boton"
        style={{
          backgroundColor:'white',
          borderWidth:'2px',
          fontSize:'15px',
          color:'rgb(0,104,178)',
          borderColor:'rgb(35,148,212)',
          fontFamily: 'report-bold'
        }}
                  onClick={ () => {
                    
                    getContar()
                  }}
        >Add iteration Logger</Button>
         <p> &nbsp;&nbsp;&nbsp; </p>
        <Button className="boton"
         style={{
          backgroundColor:'white',
          borderWidth:'2px',
          fontSize:'15px',
          color:'rgb(0,104,178)',
          borderColor:'rgb(35,148,212)',
          fontFamily: 'report-bold'
        }}
                  onClick={ () => {
                    const publicIP = getPublicIP();
                    // console.log(publicIP)
                    getContarError()
                  }}
                  >Add iteration Error</Button>
      </div>
      
      <h2 style={{fontFamily: 'report-bold'}}>
        Errors history:
      </h2>
      <div style={{border: '5px solid rgb(203,234,247)',padding:'0px'}}>
        <TablePlot data={dataSourceError} columns={columnsError} />
      </div>
      {/* <div className="hola">
        <pre>{json}</pre>
      </div> */}
    </>
  );
}
